import React from 'react';
import { Flex, Text } from '@chakra-ui/react';

type IProps = {};

export const SelectEmptyState: React.FC<IProps> = () => {
  return (
    <Flex flexDirection={'column'}>
      {/* Temporary placeholder empty state text */}
      <Text textStyle={'textBody'}>No data available</Text>
    </Flex>
  );
};
